import Contact from './../models/Contact';
import { orderby } from 'lodash';
import Base from './Base';

export default class Contacts extends Base {
    get models() {
        const collection = this.data.map(item => new Contact(item));
        collection.collection = this;

        return collection;
    }

    get modelsSorted() {
        const collection = orderby(this.models, 'full_name', 'asc');
        collection.collection = this;

        return collection;
    }

    get modelsSortedHubSpot() {
        const collection = this.modelsSorted.filter(item => item.hasIntegrationType);
        collection.collection = this;

        return collection;
    }
}
